import React from 'react'

import doc from '../../static/logos/doc.png'
import docWithPointer from '../../static/logos/doc_with_pointer_orange.png'
// import docWithPointer from '../../../static/logos/doc_with_pointer.png'


const Publication = ({ publication }) => {
  const {
    url,
    citation,
    year,
    therapeutic_areas,
    publication_url,
    show_url_on_website
  } = publication

  function renderURLIcon() {
    if (show_url_on_website) {
      return (
        <a href={publication_url} target="__blank">
          <img src={docWithPointer} alt=''/>
        </a>
      )
    } else {
      return (
        // eslint-disable-next-line
        <a href="" style={{pointerEvents: 'none'}}>
          <img style={{opacity: "0"}} src={doc} alt=''/>
        </a>
      )
    }
  }

  return (
    <li key={url}>
      {renderURLIcon()}
      <div style={{width: "100%"}}>
        <p><b>Citation:</b></p>
        <p dangerouslySetInnerHTML={{__html: citation}}></p>
        <div className="pub-metadata">
          <p><b>Published:</b> {year}</p>
          <p><b>Therapeutic area(s):</b> { therapeutic_areas && therapeutic_areas.length ? therapeutic_areas.join(", ") : "N/A"}</p>
        </div>
      </div>
    </li>
  )
}

export default Publication